/**
 * Country codes data for international phone number support.
 * Thailand is first, then sorted alphabetically by nameEn.
 * phoneLength: array of valid national number lengths (without country code or leading 0).
 */
const countryCodes = [
  { code: "TH", dialCode: "+66", nameTh: "ไทย", nameEn: "Thailand", flag: "🇹🇭", phoneLength: [9] },
  { code: "AU", dialCode: "+61", nameTh: "ออสเตรเลีย", nameEn: "Australia", flag: "🇦🇺", phoneLength: [9] },
  { code: "BN", dialCode: "+673", nameTh: "บรูไน", nameEn: "Brunei", flag: "🇧🇳", phoneLength: [7] },
  { code: "KH", dialCode: "+855", nameTh: "กัมพูชา", nameEn: "Cambodia", flag: "🇰🇭", phoneLength: [8, 9] },
  { code: "CN", dialCode: "+86", nameTh: "จีน", nameEn: "China", flag: "🇨🇳", phoneLength: [11] },
  { code: "FR", dialCode: "+33", nameTh: "ฝรั่งเศส", nameEn: "France", flag: "🇫🇷", phoneLength: [9] },
  { code: "DE", dialCode: "+49", nameTh: "เยอรมนี", nameEn: "Germany", flag: "🇩🇪", phoneLength: [10, 11] },
  { code: "HK", dialCode: "+852", nameTh: "ฮ่องกง", nameEn: "Hong Kong", flag: "🇭🇰", phoneLength: [8] },
  { code: "IN", dialCode: "+91", nameTh: "อินเดีย", nameEn: "India", flag: "🇮🇳", phoneLength: [10] },
  { code: "ID", dialCode: "+62", nameTh: "อินโดนีเซีย", nameEn: "Indonesia", flag: "🇮🇩", phoneLength: [9, 10, 11, 12] },
  { code: "JP", dialCode: "+81", nameTh: "ญี่ปุ่น", nameEn: "Japan", flag: "🇯🇵", phoneLength: [10] },
  { code: "KR", dialCode: "+82", nameTh: "เกาหลีใต้", nameEn: "South Korea", flag: "🇰🇷", phoneLength: [9, 10] },
  { code: "LA", dialCode: "+856", nameTh: "ลาว", nameEn: "Laos", flag: "🇱🇦", phoneLength: [8, 9] },
  { code: "MY", dialCode: "+60", nameTh: "มาเลเซีย", nameEn: "Malaysia", flag: "🇲🇾", phoneLength: [9, 10] },
  { code: "MM", dialCode: "+95", nameTh: "เมียนมา", nameEn: "Myanmar", flag: "🇲🇲", phoneLength: [8, 9, 10] },
  { code: "NZ", dialCode: "+64", nameTh: "นิวซีแลนด์", nameEn: "New Zealand", flag: "🇳🇿", phoneLength: [8, 9] },
  { code: "PH", dialCode: "+63", nameTh: "ฟิลิปปินส์", nameEn: "Philippines", flag: "🇵🇭", phoneLength: [10] },
  { code: "RU", dialCode: "+7", nameTh: "รัสเซีย", nameEn: "Russia", flag: "🇷🇺", phoneLength: [10] },
  { code: "SA", dialCode: "+966", nameTh: "ซาอุดีอาระเบีย", nameEn: "Saudi Arabia", flag: "🇸🇦", phoneLength: [9] },
  { code: "SG", dialCode: "+65", nameTh: "สิงคโปร์", nameEn: "Singapore", flag: "🇸🇬", phoneLength: [8] },
  { code: "TW", dialCode: "+886", nameTh: "ไต้หวัน", nameEn: "Taiwan", flag: "🇹🇼", phoneLength: [9] },
  { code: "AE", dialCode: "+971", nameTh: "สหรัฐอาหรับเอมิเรตส์", nameEn: "UAE", flag: "🇦🇪", phoneLength: [9] },
  { code: "GB", dialCode: "+44", nameTh: "อังกฤษ", nameEn: "United Kingdom", flag: "🇬🇧", phoneLength: [10] },
  { code: "US", dialCode: "+1", nameTh: "สหรัฐอเมริกา", nameEn: "United States", flag: "🇺🇸", phoneLength: [10] },
  { code: "VN", dialCode: "+84", nameTh: "เวียดนาม", nameEn: "Vietnam", flag: "🇻🇳", phoneLength: [9, 10] },
];

export default countryCodes;

export function findCountryByCode(code) {
  return countryCodes.find((c) => c.code === code) || countryCodes[0];
}

export function findCountryByDialCode(dialCode) {
  return countryCodes.find((c) => c.dialCode === dialCode);
}
